module.exports = __webpack_public_path__ + "img/dfm.9a41355c.png";